module.exports = __webpack_public_path__ + "static/media/system-oto-modulesB-img.f404dec9.png";